import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Comparable } from '../../models/comparables.type';

@Injectable({
  providedIn: 'root'
})
export class ComparablesService {

  private _comparables$ = new BehaviorSubject<Comparable[] | null>(null);
  readonly comparables$ = this._comparables$.asObservable();

  constructor(private http: HttpClient) {}

  getComparables(activityNumber: string): Observable<Comparable[]> {
    const url = `${environment.apiBaseUrl}/api/v1/comparables/${activityNumber}`;
    return this.http.get<Comparable[]>(url);
  }

  /** Load and cache for children to use */
  loadComparables(activityNumber: string): Observable<Comparable[]> {
    return this.getComparables(activityNumber).pipe(
      tap(list => this._comparables$.next(list))
    );
  }

  /** Convenience filtered streams by kind */
  sales$   = this.comparables$.pipe(map(xs => (xs ?? []).filter(x => (x.kind ?? x.snapshot?.kind) === 'Sales')));
  rent$    = this.comparables$.pipe(map(xs => (xs ?? []).filter(x => (x.kind ?? x.snapshot?.kind) === 'Rent')));
  expense$ = this.comparables$.pipe(map(xs => (xs ?? []).filter(x => (x.kind ?? x.snapshot?.kind) === 'Expense')));
  land$    = this.comparables$.pipe(map(xs => (xs ?? []).filter(x => (x.kind ?? x.snapshot?.kind) === 'Land')));

}
